import Advertise from "./Advertise";
import "./Css/GameSidebar.css"; // Adjust the path as necessary

const sampleImages = [
  "advertise1.jpg",
  "advertise2.jpg",
  "advertise3.jpg",
  "advertise4.jpg",
  "advertise5.jpg",
  "advertise6.jpg",
  "advertise7.jpg",
  "advertise8.jpg",
  "advertise9.jpg",
  "advertise10.jpg",
];

const AdvertisementLeft = () => {
  return (
    <>
      <div className={`sidebar left sidebar_mobile`}>
        <h4 className="ad-title"> Advertisement</h4>
        {/* { 
      sampleImages && sampleImages.map((game, idx) => (
          <div className="sidebar-img" key={idx} >
             <img style ={{width:'120px',height:"115px"}} src={`${game}`} alt={`Addvertise ${idx}`} />
            
          </div>
        ))
      } */}
        <Advertise slot="9090538211" width="160px" wrapperWidth="auto" />
      </div>
    </>
  );
};

export default AdvertisementLeft;
